import FillSymbol from './FillSymbol';
import SymbolFactory from './SymbolFactory';

/**
 * 复合符号面填充类.
 */
export default class CompositeFillSymbol extends FillSymbol {
    constructor(options) {
        super(options);

        this.symbols = [];
        this.type = 'CompositeFillSymbol';

        this.fromJson(options);
    }

    fromJson(json) {
        super.fromJson(json);

        if (!json.symbols) {
            return;
        }

        const symbolFactory = SymbolFactory.getInstance();
        for (let i = 0; i < json.symbols.length; ++i) {
            this.symbols.push(symbolFactory.createSymbol(json.symbols[i]));
        }
    }

    toJson() {
        const json = super.toJson();

        json.symbols = [];
        for (let i = 0; i < this.symbols.length; ++i) {
            json.symbols.push(this.symbols[i].toJson());
        }

        return json;
    }

    draw(ctx, geometry) {
        if (!this.symbols.length || this.symbols.length === 0) {
            return;
        }

        super.draw(ctx, geometry);

        for (let i = 0; i < this.symbols.length; ++i) {
            this.symbols[i].draw(ctx, geometry);
        }
    }
}
